import { PropsWithChildren } from 'react'

import { GlobalStateProvider } from './global-state'
import StateInspector from './state-inspector'

const AppProviders = ({ children }: PropsWithChildren<unknown>) => (
  <StateInspector>
    <GlobalStateProvider>{children}</GlobalStateProvider>
  </StateInspector>
)

export default AppProviders
